import Highcharts, { Options } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import noDataToDisplay from "highcharts/modules/no-data-to-display";
import { useSelector } from "react-redux";
import { useRef, useEffect } from "react";

import { DashboardSelectors } from "../../../redux/selectors/unifiedSelectors";

noDataToDisplay(Highcharts);

const NewActivityChart = (t: (arg0: string) => string) => {
  const { activityData } = useSelector(DashboardSelectors);
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  const cereals = activityData.data;
  const useCerealsData = Array.isArray(cereals) && cereals.length > 0;
  const isLoading = activityData.loading;

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (isLoading) {
        chart.showLoading();
      } else {
        chart.hideLoading();
      }
    }
  }, [isLoading]);

  const generateSeriesFromCereals = () => {
    if (!useCerealsData) return [];

    return cereals.map((cereal: any, index: number) => {
      return {
        type: "area" as const,
        name: cereal.specie,
        data: cereal.countInfo.map((item: any) =>
          Number.parseInt(item.activity),
        ),
        color: cereal.color,
      };
    });
  };

  const generateCategoriesFromCereals = () => {
    if (!useCerealsData || cereals.length === 0) return [];

    const firstCereal = cereals[0];
    if (!firstCereal?.countInfo) return [];

    return firstCereal.countInfo.map((item: any) => {
      return item.date || "";
    });
  };

  const dynamicSeries = generateSeriesFromCereals();
  const dynamicCategories = generateCategoriesFromCereals();

  const chartOptions: Options = {
    chart: {
      type: "area",
    },
    loading: {
      hideDuration: 1000,
      showDuration: 1000,
      labelStyle: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    lang: {
      loading: `...${t("Common_options.Loading")}`,
    },

    title: {
      text: "",
    },

    series: dynamicSeries,

    yAxis: {
      title: {
        text: "",
      },
    },
    xAxis: {
      categories: dynamicCategories,
      title: {},
    },
  };

  return (
    <HighchartsReact
      ref={chartRef}
      containerProps={{
        style: {
          width: "100%",
        },
      }}
      highcharts={Highcharts}
      options={chartOptions}
    />
  );
};

export default NewActivityChart;
